export default {
  actions: {
    Login(ctx, data) {
      axios
        .post(data.path + '/login', {
          headers: {
            'Content-Type': 'application/json'
          },
          'email': data.email,
          'password': data.password,
          'cart_id': localStorage.getItem('cart_id'),
        })
        .then(response => {
          localStorage.setItem('access_token', response.data.token.access_token);
          localStorage.setItem('refresh_token', response.data.token.refresh_token);
          localStorage.setItem('user', JSON.stringify(response.data.data));
          ctx.commit('updateIsAuthStatus');
          ctx.commit('updateAuthUser', response.data.data);
          let href = `/${data.lang}/profile`;
//          if (localStorage.getItem('checkout_started')) {
//            localStorage.removeItem('checkout_started')
//            href += '?checkout'
//          }
          if(data.redirect){
            href = '/' + data.lang + '/' + data.redirect;
          }
//          console.log(href);
//          console.log(data);
          window.location.replace(href);
          let date = new Date();
          date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
          document.cookie = `user_email=${response.data.data.email}; expires=${date.toUTCString()}`;
          this._vm.$gtag.event('login', {
            method: 'Email',
          })
          setTimeout(() => {
            if (window.fbq) {
              window.fbq('trackCustom', 'Login', {
                status: true,
                currency: "EUR",
                content_name: 'Email'
              })
            }
          })
        })
        .catch(err => {
          console.error('Login error (Email):', err)
          if (err.response.data && err.response.data.errors.email) {
            ctx.commit('updateEmailError', err.response.data.errors.email[0])
          } else if (err.response.data && err.response.data.errors.login[0]) {
            ctx.commit('updateLoginError', err.response.data.errors.login[0])
          } else if (err.response.data && err.response.data.errors.message) {
            ctx.commit('updatePassError', err.response.data.errors.message)
          }
          setTimeout(function () {
            ctx.commit('updateEmailError', '');
            ctx.commit('updateLoginError', '');
            ctx.commit('updatePassError', '');
          }, 5000)
        })
    },
    LoginByFaceBook(ctx, data) {
      axios
        .post(data.path + '/auth/facebook', {
          headers: {
            'Content-Type': 'application/json'
          },
          'fb_token': data.fb_token,
          'cart_id': localStorage.getItem('cart_id'),
        })
        .then(response => {
          localStorage.setItem('access_token', response.data.token.access_token);
          localStorage.setItem('refresh_token', response.data.token.refresh_token);
          localStorage.setItem('user', JSON.stringify(response.data.data));
          ctx.commit('updateIsAuthStatus');
          ctx.commit('updateAuthUser', response.data.data);
          let href = `/${data.lang}/profile`;
          //if (localStorage.getItem('checkout_started')) {
          //  localStorage.removeItem('checkout_started')
          //  href += '?checkout'
          //}
          if(data.redirect){
            href = '/' + data.lang + '/' + data.redirect;
          }
          window.location.replace(href);
          let eventName = data.register === true ? 'sign_up' : 'login';
          this._vm.$gtag.event(eventName, {
            method: 'Facebook',
          })
          setTimeout(() => {
            if (window.fbq) {
              if (this.register === true) {
                window.fbq('track', 'CompleteRegistration', {
                  status: true,
                  currency: "EUR",
                  content_name: 'Facebook'
                })
              } else {
                window.fbq('trackCustom', 'Login', {
                  status: true,
                  currency: "EUR",
                  content_name: 'Facebook'
                })
              }
            }
          })
        }).catch(err => {
        console.error('Login error (FB):', err)
        ctx.commit('updateLoginError', 'Server Error, try later')
      })
    },
    ResendVerificationLink(ctx, data) {
      return new Promise((resolve, reject) => {
        axios.get(data.path + '/email/resend', {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('access_token')}`
          }
        }).then(response => {
          resolve(200)
        }).catch(err => {
          if (err.response.status === 429) {
            resolve(429)
          } else {
            resolve(500)
          }
        })
      });
    },
    AuthUserEmail(ctx) {
      let emails = [
        'rafael.g@forestal.com',
        'Anastasia.k@forestal.com',
        'crave119@gmail.com',
        'valentin@forestal.com',
        'glapacha@gmail.com',
        'Nikita@x10squad.com',
        'user@gmail.com',
        'caesar_88@mail.ru',
        'yahin.r.r@gmail.com',
        'andrey@x10squad.com',
        'vladentsymbal01@gmail.com',
        'darthsanches2@mail.ru',
        'anton.yarashuk@gmail.com',
      ];

      ctx.commit('showPages', true)

      // if(localStorage.getItem('user') && ctx.getters.isAuth){
      //
      //     let userEmail = JSON.parse(localStorage.getItem('user')).email
      //     let found = emails.find(function (email){
      //         return email === userEmail;
      //     })
      //
      //     if(found) {
      //         ctx.commit('showPages', true)
      //     }else{
      //         ctx.commit('showPages',false)
      //     }
      // }else{
      //     ctx.commit('showPages',false)
      // }
    }
  },
  mutations: {
    updateEmailError(state, err) {
      state.EmailError = err
    },
    updateLoginError(state, err) {
      state.LoginError = err
    },
    updatePassError(state, err) {
      state.PassError = err
    },
    updateIsAuthStatus(state) {
      state.loggedIn = !!localStorage.getItem('access_token')
    },
    updateAuthUser(state, user) {
      localStorage.setItem('user', JSON.stringify(user));
      state.authUser = user
    },
    showPages(state, boolean) {
      state.showPages = boolean
    }
  },
  state: {
    EmailError: '',
    showPages: '',
    LoginError: '',
    PassError: '',
    title: 'Forestal',
    loggedIn: !!localStorage.getItem('access_token'),
    authUser: !!localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null,
  },
  getters: {
    getEmailError(state) {
      return state.EmailError
    },
    getLoginError(state) {
      return state.LoginError
    },
    getPassError(state) {
      return state.PassError
    },
    getTitle(state) {
      return state.title;
    },
    isAuth(state) {
      return state.loggedIn;
    },
    getShowPages(state) {
      return state.showPages;
    },
    getAuthUser(state) {
      return state.authUser;
    },
  }
}
